var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "shared-node"
  }, [_c("a-form-model", {
    ref: "form",
    attrs: {
      model: _vm.formData,
      "label-col": {
        span: 24
      },
      "wrapper-col": {
        span: 24
      },
      rules: _vm.rules
    }
  }, _vm._l(_vm.editableArea, function (formItem, index) {
    return _c("div", {
      key: `current${index}`
    }, [formItem.formName ? _c("top-title", {
      key: index
    }, [_c("span", {
      attrs: {
        slot: "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.$t(formItem.formName)))])]) : _vm._e(), _vm._l(formItem.form, function (item2, controlIndex) {
      return _c("div", {
        key: controlIndex
      }, [item2.controlType === "control" && _vm.showControl[item2.control.mark] ? _c("div", [_c("formControlItem", {
        ref: `control${item2.control.mark}`,
        refInFor: true,
        attrs: {
          formData: _vm.formData,
          controlItem: item2.control,
          echoNodeIsEdit: _vm.echoNodeIsEdit,
          associationInfo: _vm.associationInfo
        },
        on: {
          valueChange: _vm.valueChangeValidate,
          changeControlShow: _vm.changeControlShow
        }
      })], 1) : item2.controlType === "controlGroup" && _vm.showControl[item2.mark] ? _c("div", [_c("h4", [_vm._v(_vm._s(item2.controlName))]), _vm._l(item2.control, function (subControl, subControlIndex) {
        return _c("div", {
          key: subControlIndex
        }, [_c("formControlItem", {
          ref: `control${subControl.mark}`,
          refInFor: true,
          attrs: {
            formData: _vm.formData,
            controlItem: subControl,
            echoNodeIsEdit: _vm.echoNodeIsEdit,
            associationInfo: _vm.associationInfo
          },
          on: {
            valueChange: _vm.valueChangeValidate,
            changeControlShow: _vm.changeControlShow
          }
        })], 1);
      })], 2) : _vm._e()]);
    })], 2);
  }), 0)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };